module.exports = __webpack_public_path__ + "media/images/varta/AKB_Banner_698x310-5cdb47d53fe23591daeb456d903a3aad.png";